import { useEffect } from "react";
import "@/App.css";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Portfolio from "./pages/Portfolio";
import ProjectDetail from "./pages/ProjectDetail";
import About from "./pages/About";
import Awards from "./pages/Awards";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

const Layout = () => {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");

    return (
        <>
            {!isAdmin && <Nav />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/work" element={<Portfolio />} />
                <Route path="/work/:id" element={<ProjectDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/awards" element={<Awards />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="*" element={<Home />} />
            </Routes>
            {!isAdmin && <Footer />}
        </>
    );
};

function App() {
    return (
        <div className="App grain">
            <BrowserRouter>
                <ScrollToTop />
                <Layout />
                <Toaster
                    theme="dark"
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: "hsl(0 0% 8%)",
                            color: "hsl(0 0% 95%)",
                            border: "1px solid hsl(0 0% 18%)",
                            borderRadius: 0,
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
